import { SearchOutlined } from '@ant-design/icons';
import { Col, Input, Row, Space } from 'antd';
import { FC } from 'react';
import styles from './index.module.scss';

interface SearchAndFilterProps {
    performSearchHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
    searchValue: string;
}

const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
    const { performSearchHandler, searchValue } = props;

    return (
        <div className={styles['search-filter']}>
            <div className={styles['search-filter__wrapper']}>
                <Row>
                    <Col>
                        <Space>
                            <Input
                                className={styles['search-filter__search']}
                                placeholder="Search expense group"
                                suffix={<SearchOutlined />}
                                onChange={performSearchHandler}
                                value={searchValue}
                                size="large"
                            />

                        </Space>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default SearchAndFilter;
